// extracted by mini-css-extract-plugin
export default {"contact":"ContactInfo_contact__JXiSY","text":"ContactInfo_text__aHDee","icons":"ContactInfo_icons__06luw"};